import React from 'react';
import axios from 'axios';
import {Formik, Form, useField} from 'formik';
import * as yup from 'yup';

import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import SendIcon from '@material-ui/icons/Send';
import Alert from '@material-ui/lab/Alert';
import I18n from './I18n';

const useStyles = makeStyles((theme) => ({
	form: {
		margin: theme.spacing(2)
	},
	content: {
		marginTop: theme.spacing(-5),
		paddingLeft: theme.spacing(1)
	},
	message: {
		marginTop: theme.spacing(3)
	},
	alert: {
		marginTop: theme.spacing(2)
	}
}));

const CustomTextField = ({label, ...props}) => {
	const [field, meta] = useField(props);
	const errorText = meta.error && meta.touched ? meta.error : "";
	return (
		<TextField
			{...field}
			label = {label}
			placeholder = {I18n("setting.required")}
			margin = "normal"
			fullWidth
			helperText = {errorText}
			error = {!!errorText}
		/>
	);
};

const CustomMLTextField = ({label, rows, ...props}) => {
	const [field, meta] = useField(props);
	const errorText = meta.error && meta.touched ? meta.error : "";
	return (
		<TextField
			{...field}
			label = {label}
			rows = {rows}
			multiline
			variant = "outlined"
			placeholder = {I18n('setting.required')}
			margin = "normal"
			fullWidth
			helperText = {errorText}
			error = {!!errorText}
		/>
	);
};

const validationSchema = ()=>{
	const lang = (navigator.language || navigator.browserLanguage).toLowerCase();
	if (lang.indexOf("cn") !== -1)
	{
		return yup.object({
			name: yup
				.string()
				.min(1, `${I18n('setting.first_name_notice1')}`)
				.required(`${I18n('setting.first_name_notice4')}`),
			phone: yup
				.string(),
			email: yup
				.string()
				.email(`${I18n('setting.email_notice1')}`)
				.required(`${I18n('setting.email_notice2')}`),
			message: yup
				.string()
				.min(10, `${I18n('setting.message_notice1')}`)
				.required(`${I18n('setting.message_notice1')}`)
		});
	}
	else
	{
		return yup.object({
			name: yup
				.string()
				.matches(/^[A-Za-zÀ-ÖØ-öø-ÿ- ]+$/, `${I18n('setting.first_name_notice1')}`)
				.required(`${I18n('setting.first_name_notice4')}`),
			phone: yup
				.string(),
			email: yup
				.string()
				.email(`${I18n('setting.email_notice1')}`)
				.required(`${I18n('setting.email_notice2')}`),
			message: yup
				.string()
				.min(20, `${I18n('setting.message_notice1')}`)
				.required(`${I18n('setting.message_notice1')}`)
		});
	}
}

const ContactForm = ({formOpen, closeForm}) => {
	const classes = useStyles();

	return (
		<Dialog open = {formOpen} aria-labelledby = "contact-us">
			<DialogTitle id = "contact-us">{I18n("setting.contact_us")}</DialogTitle>
			<DialogContent className = {classes.content}>
				<Formik
					initialValues = {{
						name: "",
						phone: "",
						email: "",
						message: ""
					}}
					validationSchema = {validationSchema}
					onSubmit = {(data, actions) => {
						actions.setSubmitting(true);
						axios
						.post("/api/sendContactForm", data)
						.then((response) => {
							if (response.data.status === "success")
							{
								actions.resetForm();
								closeForm();
							}
							else if (response.data.status === "fail")
							{
								console.log("Message failed to send.", response.data.err);
								actions.setStatus("fail");
							}
							actions.setSubmitting(false);
						}).catch((error) => console.error(error));
					}}
				>
				{({values, isSubmitting, status}) => (
					<Form className = {classes.form}>
						<CustomTextField name = "name" label = {I18n("setting.name")} />
						<CustomTextField name = "phone" label = {I18n("setting.phone")} />
						<CustomTextField name = "email" label = {I18n("setting.email")} />
						<CustomMLTextField className = {classes.message} name = "message" label = {I18n("setting.message")} rows = "6" />
						{status === "fail" && (
							<Alert severity = "error">
								{I18n("setting.fail_error")}
							</Alert>
						)}
						<DialogActions>
							<Button onClick = {closeForm} color = "primary">
								{I18n("setting.cancel")}
							</Button>
							<Button
								type = "submit"
								disabled = {isSubmitting}
								variant = "contained"
								color = "primary"
								endIcon = {<SendIcon />}
							>
								{I18n("setting.send")}
							</Button>
						</DialogActions>
						{/*<pre>{JSON.parse(JSON.stringify(values, null, 2)).message}</pre>*/}
					</Form>
				)}
				</Formik>
			</DialogContent>
		</Dialog>
	);
};

export default ContactForm;
